import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Button from "../../../components/atoms/button";
import NavBar from "../../../components/organisms/navbar";
import useAuthenticate from "../../../hooks/useAuthenticate";
import api from "../../../services/api";
import { Content, FormContainer, PageDescription, PageTitle } from "../styles";
import SelectFighters from "../../../components/atoms/selectFighters";
import SelectCategories from "src/components/atoms/selectCategories";
import {
  Checkbox,
  Collapse,
  Fade,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import Swal from "sweetalert2";
import NoOptionsAlert from "src/components/atoms/no-options-alert";
import { Stack, Typography, Box, DialogActions, DialogContent, Dialog, DialogTitle, Button as ButtonMui, CircularProgress } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import EditFighterModal from "src/components/atoms/editAtleteModal";
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import rulesGi from "../../../data/rules-copa-parintinense-de-jiu-jitsu-2026-gi.json";
import rulesNoGi from "../../../data/rules-copa-parintinense-de-jiu-jitsu-2026-nogi.json";
import rulesGiAbsoluto from "../../../data/rules-copa-parintinense-de-jiu-jitsu-2026-absoluto-gi.json";
import rulesNogiAbsoluto from "../../../data/rules-copa-parintinense-de-jiu-jitsu-2026-absoluto-nogi.json";
import shirtsData from '../../../data/rules-xix-copa-parana-de-jiu-jitsu-2026-camisas.json'
import camisaVender from '../../../assets/images/tournaments/xix-copa-parana-de-jiu-jitsu-2026/xix-copa-parana-de-jiu-jitsu-2026-camisa.png'
import styled from "styled-components";

const StyledFormControlLabel = styled(FormControlLabel)`
  & .MuiFormControlLabel-label {
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 0.95rem;
    color: #33303E;
  }
`;

const EnrollmentCopaParintinenseDeJiuJitsu2026 = () => {
  const navigate = useNavigate();
  const { getToken, account } = useAuthenticate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    control,
    getValues
  } = useForm();

  const NomeDoTorneio = "COPA PARINTINENSE DE JIU JITSU 2026"
  const comboValue = 200;
  const giFiled = "valorInscricao";
  const noGiFiled = "valorInscricao";
  const haveGuarantee = true; // <---------------- MARCIETEEEEE, MUDE PARA EXIBIR OU NAO A GARANTIA 
  const haveTshirt = false; // <---------------- MARCIETEEEEE, MUDE PARA EXIBIR OU NAO A CAMISA DO EVENTO 

  const slugGi = "copa-parintinense-de-jiu-jitsu-parintins-am-gi";
  const slugNoGi = "copa-parintinense-de-jiu-jitsu-parintins-am-nogi";

  const modalidade = [
    { title: "Sim", option: 0 },
    { title: "Não", option: 1 }
  ];

  let { slug } = useParams();
  //let rulesGi = rulesXxxiiiCopaOrleyLobatoDeJiuJitsu2025Gi;
  //let rulesNoGi = rulesXxxiiiCopaOrleyLobatoDeJiuJitsu2025Absoluto;

  const [ages, setAges] = useState<any>([]);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [guaranteeImageLoaded, setGuaranteeImageLoaded] = useState(false);
  const [genre, setGenre] = useState<any>([]);
  const [categories, setCategories] = useState<any>([]);
  const [belts, setBelts] = useState<any>([]);
  const [weights, setWeights] = useState<any>([]);
  const [disabled, setDisabled] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [fighters, setFighters] = useState<any>([]);
  const [tournament, setTournament] = useState<any>({});
  const [enrollmentType, setEnrollmentType] = useState<String>("");
  const [categoriesNOGI, setCategoriesNOGI] = useState<any>([]);
  const [categoriesNogiAbsoluto, setCategoriesNogiAbsoluto] = useState<any>([]);
  const [categoriesGiAbsoluto, setCategoriesGiAbsoluto] = useState<any>([]);
  const [weightsGiAbsoluto, setWeightsGiAbsoluto] = useState<any>([]);
  const [weightsNOGI, setWeightsNOGI] = useState<any>([]);
  const [weightsNogiAbsoluto, setWeightsNogiAbsoluto] = useState<any>([]);
  const [selectedFighter, setSelectedFighter] = useState<any>(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [noCategoriesAvailableNogi, setNoCategoriesAvailableNogi] = useState<boolean>(false);
  const [noCategoriesAvaliableGi, setNoCategoriesAvailableGi] = useState<boolean>(false);
  const [noCategoriesAvaliableGiAbsoluto, setNoCategoriesAvailableGiAbsoluto] = useState<boolean>(false);
  const [noCategoriesAvaliableNogiAbsoluto, setNoCategoriesAvailableNogiAbsoluto] = useState<boolean>(false);
  const [windowSize, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight, });
  const [selectedFighterId, setSelectedFighterId] = useState<number | null>(null);
  const [wantsChampionGuarantee, setWantsChampionGuarantee] = useState<boolean | null>(null);
  const [shirtCategories, setShirtCategories] = useState<any[]>([]);
  const [shirtColors, setShirtColors] = useState<any[]>([]);
  const [shirtSizes, setShirtSizes] = useState<any[]>([]);
  const [wantsShirt, setWantsShirt] = useState<boolean | null>(null);
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const handleEditAtlete = () => {
    setIsEditModalOpen(true);
  };

  const handleFighterUpdated = (updated: any) => {
    const updatedData = { ...selectedFighter, ...updated };
    if (selectedFighterId == 0) {
      account.name = updated.name;
    } else {
      setFighters((prev: any) =>
        prev.map((f: any) => (f.id === updated.id ? { ...f, ...updated } : f))
      );
    }
    setSelectedFighter(updatedData);
    setIsEditModalOpen(false);
    setNoCategoriesAvailableGi(false);
    setNoCategoriesAvailableNogi(false);
    setNoCategoriesAvailableGiAbsoluto(false);
    setNoCategoriesAvailableNogiAbsoluto(false);
    setEnrollmentType("");
    setValue("gi.category", "");
    setValue("gi.weight", "");
    setValue("gi.modalidade", "");
    setValue("gi.absoluto.category", "");
    setValue("gi.absoluto.weight", "");
    setValue("gi.absoluto.modalidade", "");
    setValue("nogi.absoluto.category", "");
    setValue("nogi.absoluto.weight", "");
    setValue("nogi.absoluto.modalidade", "");
    setValue("nogi.category", "");
    setValue("nogi.weight", "");
    setValue("nogi.modalidade", "");
    setWeights([]);
    setWeightsNOGI([]);
    applyFighterLogic(updated);
  };

  const fields = [
    //{ id: 'name', label: 'Nome', value: selectedFighter?.name.toUpperCase() },
    { id: 'gym', label: 'Academia', value: selectedFighter?.gym.toUpperCase() },
    { id: 'belt', label: 'Faixa', value: belts[0]?.title?.toUpperCase() || '' },
    { id: 'age', label: 'Idade de luta', value: ages[0]?.option },
    { id: 'gender', label: 'Gênero', value: selectedFighter?.genre.toUpperCase() },
  ];

  const [checkedStates, setCheckedStates] = useState<{ [key: string]: boolean }>(
    fields.reduce((acc, field) => ({ ...acc, [field.id]: false }), {})
  );

  const allChecked = fields.every(field => checkedStates[field.id]);

  const handleCheckChange = (id: string) => {
    setCheckedStates((prev) => {
      const updated = { ...prev };
      const currentIndex = fields.findIndex((f) => f.id === id);
      const newValue = !prev[id];

      updated[id] = newValue;

      if (!newValue) {
        for (let i = currentIndex + 1; i < fields.length; i++) {
          updated[fields[i].id] = false;
        }
      }

      return updated;
    });
  };

  const verifyCanSubscribe = async () => {
    const tournamentGI = (await api.get(`/tournaments/${slugGi}`)).data;

    const tournamentNOGI = (await api.get(`/tournaments/${slugNoGi}`)).data;

    return enrollmentType === "comboGiNogiAbsolutoGi" || enrollmentType === "combo" || enrollmentType === "comboGiNogiAbsolutoNogi" || enrollmentType === "comboGiAbsolutoNogiAbsoluto"
      ? tournamentGI!.canSubscribe && tournamentNOGI!.canSubscribe
      : enrollmentType === "nogi" || enrollmentType === "absolutNOGI" || enrollmentType === "comboNogiAbsoluto"
        ? tournamentNOGI!.canSubscribe
        : enrollmentType === "gi" || enrollmentType === "comboGiAbsoluto" || enrollmentType === "absolutGI"
          ? tournamentGI!.canSubscribe
          : false;
  };

  const getTitleByOption = (array: any[], option: number) => {
    for (let i = 0; i < array.length; i++) {
      if (array[i].option === +option) {
        return array[i].title;
      }
    }
    return null;
  };

  const onSubmit = async (data: any) => {
    setLoading(true);
    setDisabled(true);
    const canSubscribe = await verifyCanSubscribe();
    const isAbsoluteCombo = enrollmentType.toLowerCase().includes('absoluto');
    //O lucas apagou toda essa constante hasNormalAndAbsoluteCombo
    // Identifica se há combo com categoria normal + absoluto
    const hasNormalAndAbsoluteCombo = enrollmentType === "comboGiAbsoluto" || 
                                       enrollmentType === "comboNogiAbsoluto" ||
                                       enrollmentType === "comboGiNogiAbsolutoGi" ||
                                       enrollmentType === "comboGiNogiAbsolutoNogi" ||
                                       enrollmentType === "comboGiAbsolutoNogiAbsoluto";

    if (!canSubscribe) {
      const msg = "Período de inscrição encerrado.";

      Swal.fire({
        title: "Atenção!",
        text: msg,
        icon: "error",
      });

      toast.error(msg);
      return;
    }



    const enrollmentIds: number[] = [];

    const arrBelts = [
      { title: "branca", option: 1 },
      { title: "cinza", option: 2 },
      { title: "amarela", option: 3 },
      { title: "laranja", option: 4 },
      { title: "verde", option: 5 },
      { title: "azul", option: 6 },
      { title: "roxa", option: 7 },
      { title: "marrom", option: 8 },
      { title: "preta", option: 9 },
    ];

    data.belt = getTitleByOption(arrBelts, data.belt);
    data.age = data.age.toString();
    delete data.fightingAge;

    if (wantsShirt) {
      data.shirt = {
        measure: data.shirt.category,
        color: data.shirt.color,
        size: data.shirt.size,
        price: data.shirt.price
      };
    } else {
      delete data.shirt
    }

    if (wantsChampionGuarantee) {
      data.championGuarantee = wantsChampionGuarantee
    }

    if (enrollmentType === "gi" ||
      enrollmentType === "combo" ||
      enrollmentType === "comboGiAbsoluto" ||
      enrollmentType === "comboGiNogiAbsolutoGi" ||
      enrollmentType === "comboGiNogiAbsolutoNogi" ||
      enrollmentType === "comboGiAbsolutoNogiAbsoluto"
    ) {
      // Verificando se `modalidade` é uma string ou número e ajustando a comparação

      console.log(data.gi.modalidade);

      const category =
        +data.gi.modalidade === 0
          ? "PCD - " + data.gi.category
          : +data.gi.modalidade === 1
            ? data.gi.category
            : "";

      const valueSubscription = rulesGi.filter(
        (r) =>
          r.idade.min <= data.age &&
          r.idade.max >= data.age &&
          r.genero === data.genre &&
          r.faixa.some((f: any) => f.nome === data.belt) &&
          r.peso.descricao === data.gi.weight &&
          r.categoria === data.gi.category
      )[0];

      slug = slugGi;

      try {
        const dataEnrollment = await api.post(
          `${"/tournaments/enrollment/" + slug}`,
          {
            //...data,
            age: data.age,
            belt: data.belt,
            genre: data.genre,
            weight: data.gi.weight,
            category: category,
            fightersId: +data.fightersId,
            valueSubscription:
              isAbsoluteCombo
                ? String(comboValue / 2)
                : String(valueSubscription[giFiled]),
            championGuarantee: data?.championGuarantee,
            //combo_subscription: isAbsoluteCombo ? "absoluto" : enrollmentType === "combo" ? 'GI' : null,
            combo_subscription: hasNormalAndAbsoluteCombo ? "normal" : enrollmentType === "combo" ? 'GI' : null,
            tshirt: data?.shirt ?? null
          },
          {
            headers: {
              Authorization: `Bearer ${getToken()}`,
            },
          }
        );

        enrollmentIds.push(dataEnrollment.data.id);
      } catch (error: any) {
        setDisabled(false);
        setLoading(false);
        Swal.fire({
          title: "Atenção!",
          text: error.response.data.message,
          icon: "error",
        });
        toast.error(
          error.response.data.message ||
          "Não foi possível gerar a sua pré-inscrição!"
        );
        return;
      }
    }

    if (enrollmentType === "absolutGI" ||
      enrollmentType === "comboGiAbsoluto" ||
      enrollmentType === "comboGiNogiAbsolutoGi" ||
      enrollmentType === "comboGiAbsolutoNogiAbsoluto"
    ) {
      // Verificando se `modalidade` é uma string ou número e ajustando a comparação

      const category =
        +data.gi.absoluto.modalidade === 0
          ? "PCD - " + data.gi.category
          : +data.gi.absoluto.modalidade === 1
            ? data.gi.absoluto.category
            : "";

      const valueSubscription = rulesGiAbsoluto.filter(
        (r) =>
          r.idade.min <= data.age &&
          r.idade.max >= data.age &&
          r.genero === data.genre &&
          r.faixa.some((f: any) => f.nome === data.belt) &&
          r.peso.descricao === data.gi.absoluto.weight &&
          r.categoria === data.gi.absoluto.category
      )[0];

      if (
        enrollmentType === "comboGiAbsoluto" ||
        enrollmentType === "comboGiNogiAbsolutoGi" ||
        enrollmentType === "comboGiAbsolutoNogiAbsoluto"
      ) {
        delete data.shirt
      }

      slug = slugGi;

      try {
        const dataEnrollment = await api.post(
          `${"/tournaments/enrollment/" + slug}`,
          {
            //...data,
            age: data.age,
            belt: data.belt,
            genre: data.genre,
            weight: data.gi.absoluto.weight,
            category: category,
            fightersId: +data.fightersId,
            valueSubscription:
              isAbsoluteCombo
                ? String(comboValue / 2)
                : String(valueSubscription[giFiled]),
            championGuarantee: data?.championGuarantee,
            combo_subscription: isAbsoluteCombo ? "absoluto" : null,
            tshirt: data?.shirt ?? null
          },
          {
            headers: {
              Authorization: `Bearer ${getToken()}`,
            },
          }
        );

        enrollmentIds.push(dataEnrollment.data.id);
      } catch (error: any) {
        console.log(error)
        setDisabled(false);
        setLoading(false);
        Swal.fire({
          title: "Atenção!",
          text: error.response.data.message,
          icon: "error",
        });
        toast.error(
          error.response.data.message ||
          "Não foi possível gerar a sua pré-inscrição!"
        );
        return;
      }
    }

    if (enrollmentType === "nogi" ||
      enrollmentType === "combo" ||
      enrollmentType === "comboNogiAbsoluto" ||
      enrollmentType === "comboGiNogiAbsolutoGi" ||
      enrollmentType === "comboGiNogiAbsolutoNogi" ||
      enrollmentType === "comboGiAbsolutoNogiAbsoluto"
    ) {
      // Verificando se `modalidade` é uma string ou número e ajustando a comparação
      const category =
        +data.nogi.modalidade === 0
          ? "PCD - " + data.nogi.category
          : +data.nogi.modalidade === 1
            ? data.nogi.category
            : "";

      const valueSubscription = rulesNoGi.filter(
        (r) =>
          r.idade.min <= data.age &&
          r.idade.max >= data.age &&
          r.genero === data.genre &&
          r.faixa.some((f: any) => f.nome === data.belt) &&
          r.peso.descricao === data.nogi.weight &&
          r.categoria === data.nogi.category
      )[0];

      if (enrollmentType === 'combo') {
        delete data.shirt
      }


      slug = slugNoGi;

      try {
        const dataEnrollment = await api.post(
          `${"/tournaments/enrollment/" + slug}`,
          {
            //...data,
            slug: slug,
            age: data.age,
            belt: data.belt,
            genre: data.genre,
            weight: data.nogi.weight,
            category: category,
            fightersId: +data.fightersId,
            valueSubscription:
              isAbsoluteCombo
                ? String(comboValue / 2)
                : String(valueSubscription[noGiFiled]),
            // combo_subscription: isAbsoluteCombo ? "absoluto" : enrollmentType === "combo" ? 'NOGI' : null,    
            combo_subscription: hasNormalAndAbsoluteCombo ? "normal" : enrollmentType === "combo" ? 'NOGI' : null,
            championGuarantee: data?.championGuarantee,
            tshirt: data?.shirt ?? null
          },
          {
            headers: {
              Authorization: `Bearer ${getToken()}`,
            },
          }
        );

        enrollmentIds.push(dataEnrollment.data.id);
      } catch (error: any) {
        setDisabled(false);
        setLoading(false);
        Swal.fire({
          title: "Atenção!",
          text: error.response.data.message,
          icon: "error",
        });
        toast.error(
          error.response.data.message ||
          "Não foi possível gerar a sua pré-inscrição!"
        );
        return;
      }
    }

    if (
      enrollmentType === "absolutNOGI" ||
      enrollmentType === "comboNogiAbsoluto" ||
      enrollmentType === "comboGiNogiAbsolutoNogi" ||
      enrollmentType === "comboGiAbsolutoNogiAbsoluto"
    ) {
      // Verificando se `modalidade` é uma string ou número e ajustando a comparação
      const category =
        +data.nogi.absoluto.modalidade === 0
          ? "PCD - " + data.nogi.absoluto.category
          : +data.nogi.absoluto.modalidade === 1
            ? data.nogi.absoluto.category
            : "";

      const valueSubscription = rulesNogiAbsoluto.filter(
        (r) =>
          r.idade.min <= data.age &&
          r.idade.max >= data.age &&
          r.genero === data.genre &&
          r.faixa.some((f: any) => f.nome === data.belt) &&
          r.peso.descricao === data.nogi.absoluto.weight &&
          r.categoria === data.nogi.absoluto.category
      )[0];

      if (
        enrollmentType === 'comboNogiAbsoluto' ||
        enrollmentType === "comboNogiAbsoluto" ||
        enrollmentType === "comboGiNogiAbsolutoNogi" ||
        enrollmentType === "comboGiAbsolutoNogiAbsoluto"
      ) {
        delete data.shirt
      }


      slug = slugNoGi;

      try {
        const dataEnrollment = await api.post(
          `${"/tournaments/enrollment/" + slug}`,
          {
            //...data,
            slug: slug,
            age: data.age,
            belt: data.belt,
            genre: data.genre,
            weight: data.nogi.absoluto.weight,
            category: category,
            fightersId: +data.fightersId,
            valueSubscription:
              isAbsoluteCombo
                ? String(comboValue / 2)
                : String(valueSubscription[noGiFiled]),
            combo_subscription: isAbsoluteCombo ? "absoluto" : null,
            championGuarantee: data?.championGuarantee,
            tshirt: data?.shirt ?? null
          },
          {
            headers: {
              Authorization: `Bearer ${getToken()}`,
            },
          }
        );

        enrollmentIds.push(dataEnrollment.data.id);
      } catch (error: any) {
        setDisabled(false);
        setLoading(false);
        Swal.fire({
          title: "Atenção!",
          text: error.response.data.message,
          icon: "error",
        });
        toast.error(
          error.response.data.message ||
          "Não foi possível gerar a sua pré-inscrição!"
        );
        return;
      }
    }

    if (tournament.paymentManual) {
      toast.success("A sua pre-inscrição foi realizada com sucesso!");

      setTimeout(() => {
        navigate(
          "/payment-instruction/" +
          slug +
          "/" +
          enrollmentIds.toString().replace(",", "-")
        );
      }, 2000);

      return;
    }

    api
      .post(
        "/payments/checkout",
        {
          enrollmentId: enrollmentIds,
        },
        {
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
        }
      )
      .then((res: any) => {
        toast.success("A sua pre-inscrição foi realizada com sucesso!");
        const width = 800; // Largura da nova janela
        const height = 600; // Altura da nova janela
        const left = window.screen.width / 2 - width / 2; // Calcula a posição horizontal
        const top = window.screen.height / 2 - height / 2; // Calcula a posição vertical

        if (windowSize.width < width) {
          window.open(res.data.links[1].href, "_self");
        } else {
          window.open(res.data.links[1].href, "_self");
        }
      })
      .catch((error) => {
        setDisabled(false);
        setLoading(false);
        toast.error(
          error.response.data.message ||
          "Não foi possível gerar a sua pré-inscrição!"
        );
      });
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);

    // Limpeza do evento ao desmontar o componente
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    api
      .get("/fighters", {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      })
      .then(({ data }) => {
        setLoading(false);
        setFighters([
          { id: "", name: "Selecione uma opção" },
          { id: 0, name: account.name },
          ...data,
        ]);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Não foi carregar os dados.");
      });

    api.get("tournaments/" + slug).then(({ data }) => {
      setTournament(data);
    });
  }, [account.name]);


  let weightsSerialize: any = [];
  let weightsSerializeGiAbsoluto: any = [];
  let weightsSerializeNogiAbsoluto: any = [];
  let weightsSerializeNOGI: any = [];
  let categoriesSerialize: any = [];
  let categoriesSerializeGiAbsoluto: any = [];
  let categoriesSerializeNOGI: any = [];
  let categoriesSerializeNogiAbsoluto: any = [];
  let arrWeights: any = [];
  let arrWeightsGiAbsoluto: any = [];
  let arrWeightsNOGI: any = [];
  let arrWeightsNogiAbsoluto: any = [];
  let acc: any = account;
  let fightingAge: Number;
  let formattedGenre: String;

  const applyFighterLogic = async (fighter: any) => {

    let arrCategories: any = [];
    let arrCategoriesGiAbsoluto: any = [];
    let arrCategoriesNOGI: any = [];
    let arrCategoriesNogiAbsoluto: any = [];
    let genre: any = [];
    let belts: any = [];

    const arrGenre = [
      { title: "Masculino", option: "masculino" },
      { title: "Feminino", option: "feminino" },
    ];

    const arrBelts = [
      { title: "Branca", option: 1 },
      { title: "Cinza", option: 2 },
      { title: "Amarela", option: 3 },
      { title: "Laranja", option: 4 },
      { title: "Verde", option: 5 },
      { title: "Azul", option: 6 },
      { title: "Roxa", option: 7 },
      { title: "Marrom", option: 8 },
      { title: "Preta", option: 9 },
    ];

    //============================== Genero ==============================
    genre = arrGenre.filter(
      (t) => t.option.toLowerCase() === fighter.genre.toLowerCase()
    );

    formattedGenre = genre[0]?.option.toLowerCase();
    //============================== Idade ==============================

    const dateOfTournament = new Date().getFullYear();
    const birthFightFromFighter = +fighter.birth_date
      .replace(/\//g, "-")
      .split("-")[2];
    fightingAge = dateOfTournament - birthFightFromFighter;
    setAges([{ title: fightingAge, option: fightingAge }]);

    //============================== Faixa ==============================
    belts = arrBelts.filter((b) => b.option === fighter.belt);
    setBelts(belts);

    //============================== Categoria ==============================
    rulesGi.map((item) => {
      if (
        item.idade.max >= +fightingAge &&
        item.idade.min <= +fightingAge &&
        item.genero === formattedGenre &&
        item.faixa.filter(
          (f: any) => f.nome.toLowerCase() === belts[0].title.toLowerCase()
        ).length
      ) {
        arrCategories.push({
          item: item.categoria,
          min: item.idade.min,
          max: item.idade.max,
          maxDescricao: item.idade.maxParaDescricao,
          minDescricao: item.idade.minParaDescricao,
          descricaoCompleta: item.idade.descricaoCompleta,
        });
      }
    });

    rulesGiAbsoluto.map((item) => {
      if (
        item.idade.max >= +fightingAge &&
        item.idade.min <= +fightingAge &&
        item.genero === formattedGenre &&
        item.faixa.filter(
          (f: any) => f.nome.toLowerCase() === belts[0].title.toLowerCase()
        ).length
      ) {
        arrCategoriesGiAbsoluto.push({
          item: item.categoria,
          min: item.idade.min,
          max: item.idade.max,
          maxDescricao: item.idade.maxParaDescricao,
          minDescricao: item.idade.minParaDescricao,
          descricaoCompleta: item.idade.descricaoCompleta,
        });
      }
    });

    if (arrCategoriesGiAbsoluto.length === 0) {
      setNoCategoriesAvailableGiAbsoluto(true);
    }

    if (arrCategories.length === 0) {
      setNoCategoriesAvailableGi(true);
    }

    rulesNoGi.map((item) => {
      if (
        item.idade.max >= +fightingAge &&
        item.idade.min <= +fightingAge &&
        item.genero === formattedGenre &&
        item.faixa.filter(
          (f: any) => f.nome.toLowerCase() === belts[0].title.toLowerCase()
        ).length
      ) {
        arrCategoriesNOGI.push({
          item: item.categoria,
          min: item.idade.min,
          max: item.idade.max,
          maxDescricao: item.idade.maxParaDescricao,
          minDescricao: item.idade.minParaDescricao,
          descricaoCompleta: item.idade.descricaoCompleta,
        });
      }
    });

    rulesNogiAbsoluto.map((item) => {
      if (
        item.idade.max >= +fightingAge &&
        item.idade.min <= +fightingAge &&
        item.genero === formattedGenre &&
        item.faixa.filter(
          (f: any) => f.nome.toLowerCase() === belts[0].title.toLowerCase()
        ).length
      ) {
        arrCategoriesNogiAbsoluto.push({
          item: item.categoria,
          min: item.idade.min,
          max: item.idade.max,
          maxDescricao: item.idade.maxParaDescricao,
          minDescricao: item.idade.minParaDescricao,
          descricaoCompleta: item.idade.descricaoCompleta,
        });
      }
    });

    let uniqueArray = [];
    let itemSet = new Set();

    if (arrCategoriesNOGI.length === 0) {
      setNoCategoriesAvailableNogi(true);
    }

    for (const obj of arrCategories) {
      if (!itemSet.has(obj.item)) {
        itemSet.add(obj.item);
        uniqueArray.push(obj);
      }
    }

    categoriesSerialize = [...new Set(uniqueArray)].map((category: any) => {
      return {
        title:
          `${category.item} - ${category.descricaoCompleta}`.toUpperCase(),
        option: category.item,
      };
    });

    uniqueArray = [];
    itemSet = new Set();

    for (const obj of arrCategoriesNOGI) {
      if (!itemSet.has(obj.item)) {
        itemSet.add(obj.item);
        uniqueArray.push(obj);
      }
    }

    categoriesSerializeNOGI = [...new Set(uniqueArray)].map(
      (category: any) => {
        return {
          title:
            `${category.item} - ${category.descricaoCompleta}`.toUpperCase(),
          option: category.item,
        };
      }
    );

    uniqueArray = [];
    itemSet = new Set();

    for (const obj of arrCategoriesGiAbsoluto) {
      if (!itemSet.has(obj.item)) {
        itemSet.add(obj.item);
        uniqueArray.push(obj);
      }
    }

    categoriesSerializeGiAbsoluto = [...new Set(uniqueArray)].map(
      (category: any) => {
        return {
          title:
            `${category.item} - ${category.descricaoCompleta}`.toUpperCase(),
          option: category.item,
        };
      }
    );

    uniqueArray = [];
    itemSet = new Set();

    for (const obj of arrCategoriesNogiAbsoluto) {
      if (!itemSet.has(obj.item)) {
        itemSet.add(obj.item);
        uniqueArray.push(obj);
      }
    }

    categoriesSerializeNogiAbsoluto = [...new Set(uniqueArray)].map(
      (category: any) => {
        return {
          title:
            `${category.item} - ${category.descricaoCompleta}`.toUpperCase(),
          option: category.item,
        };
      }
    );

    setGenre([...genre]);
    setBelts([...belts]);
    setValue("genre", genre[0]?.option);
    setValue("age", fightingAge);
    setValue("belt", belts[0]?.option);
    setValue("category", "");
    setCategories([
      {
        title: "Selecione uma opção",
        option: "",
      },
      ...categoriesSerialize,
    ]);
    setCategoriesNOGI([
      {
        title: "Selecione uma opção",
        option: "",
      },
      ...categoriesSerializeNOGI,
    ]);
    setCategoriesGiAbsoluto([
      {
        title: "Selecione uma opção",
        option: "",
      },
      ...categoriesSerializeGiAbsoluto,
    ]);
    setCategoriesNogiAbsoluto([
      {
        title: "Selecione uma opção",
        option: "",
      },
      ...categoriesSerializeNogiAbsoluto,
    ]);


    setSelectedFighter(fighter);

  }

  const handleChange = (e: any) => {
    setValue("category", "");
    setValue("weight", "");
    setValue("modalidade", "");
    setWantsChampionGuarantee(null);
    setWantsShirt(null);
    setEnrollmentType("")
    setCategories([]);
    setCategoriesGiAbsoluto([]);
    setCategoriesNOGI([]);
    setCategoriesNogiAbsoluto([]);
    setWeights([]);
    setWeightsGiAbsoluto([]);
    setWeightsNOGI([]);
    setWeightsNogiAbsoluto([]);
    setNoCategoriesAvailableGi(false);
    setNoCategoriesAvailableGiAbsoluto(false);
    setNoCategoriesAvailableNogi(false);
    setNoCategoriesAvailableNogiAbsoluto(false);

    // RESETAR OS CHECKS COM APÓS MUDANÇA
    const resetStates = fields.reduce((acc, field) => {
      acc[field.id] = false;
      return acc;
    }, {} as { [key: string]: boolean });

    setCheckedStates(resetStates);

    const id = +e.target.value;
    setSelectedFighterId(id);

    if (id == 0) {
      applyFighterLogic(acc)
    } else {
      const fighter = fighters.find((f: any) => +f.id === id)!;
      applyFighterLogic(fighter)
    };
  }
  //============================== Peso ==============================
  const handleChangeWeights = (e: any) => {
    setValue("gi.weight", "");

    rulesGi.map((item) => {
      if (
        item.idade.max >= +ages[0]?.title &&
        item.idade.min <= +ages[0]?.title &&
        item.genero === genre[0].title.toLowerCase() &&
        item.categoria === e.target.value &&
        item.faixa.filter(
          (f: any) => f.nome.toLowerCase() === belts[0].title.toLowerCase()
        ).length
      ) {
        arrWeights.push({
          peso: item.peso.descricao,
          massa: item.peso.max,
        });
      }
    });

    console.log(fightingAge);

    weightsSerialize = [...new Set(arrWeights)].map((category: any) => {
      return {
        title: `${category.peso} - ${category.massa} `.toUpperCase(),
        option: category.peso,
      };
    });

    setWeights([
      {
        title: "Selecione uma opção",
        option: "",
      },
      ...weightsSerialize,
    ]);

  };

  const handleChangeWeightsGiAbsoluto = (e: any) => {
    setValue("gi.absoluto.weight", "");

    rulesGiAbsoluto.map((item) => {
      if (
        item.idade.max >= +ages[0]?.title &&
        item.idade.min <= +ages[0]?.title &&
        item.genero === genre[0]?.title?.toLowerCase() &&
        item.categoria === e.target.value &&
        item.faixa.filter(
          (f: any) => f.nome.toLowerCase() === belts[0]?.title?.toLowerCase()
        ).length
      ) {
        arrWeightsGiAbsoluto.push({
          peso: item.peso.descricao,
          massa: item.peso.max,
        });
      }
    });

    weightsSerializeGiAbsoluto = [...new Set(arrWeightsGiAbsoluto)].map((category: any) => {
      return {
        title: `${category.peso} - ${category.massa} `.toUpperCase(),
        option: category.peso,
      };
    });

    setWeightsGiAbsoluto([
      {
        title: "Selecione uma opção",
        option: "",
      },
      ...weightsSerializeGiAbsoluto,
    ]);

  };

  const handleChangeWeightsNOGI = (e: any) => {
    setValue("nogi.weight", "");

    rulesNoGi.map((item) => {
      if (
        item.idade.max >= +ages[0].option &&
        item.idade.min <= +ages[0].option &&
        item.genero === genre[0].title.toLowerCase() &&
        item.categoria === e.target.value &&
        item.faixa.filter(
          (f: any) => f.nome.toLowerCase() === belts[0].title.toLowerCase()
        ).length
      ) {
        arrWeightsNOGI.push({
          peso: item.peso.descricao,
          massa: item.peso.max,
        });
      }
    });

    weightsSerializeNOGI = [...new Set(arrWeightsNOGI)].map((category: any) => {
      return {
        title: `${category.peso} - ${category.massa}`.toUpperCase(),
        option: category.peso,
      };
    });

    setWeightsNOGI([
      {
        title: "Selecione uma opção",
        option: "",
      },
      ...weightsSerializeNOGI,
    ]);
  };

  const handleChangeWeightsNogiAbsoluto = (e: any) => {
    setValue("nogi.absoluto.weight", "");

    rulesNogiAbsoluto.map((item) => {
      if (
        item.idade.max >= +ages[0].option &&
        item.idade.min <= +ages[0].option &&
        item.genero === genre[0].title.toLowerCase() &&
        item.categoria === e.target.value &&
        item.faixa.filter(
          (f: any) => f.nome.toLowerCase() === belts[0].title.toLowerCase()
        ).length
      ) {
        arrWeightsNogiAbsoluto.push({
          peso: item.peso.descricao,
          massa: item.peso.max,
        });
      }
    });

    weightsSerializeNogiAbsoluto = [...new Set(arrWeightsNogiAbsoluto)].map((category: any) => {
      return {
        title: `${category.peso} - ${category.massa}`.toUpperCase(),
        option: category.peso,
      };
    });

    setWeightsNogiAbsoluto([
      {
        title: "Selecione uma opção",
        option: "",
      },
      ...weightsSerializeNogiAbsoluto
    ]);
  };

  useEffect(() => {
    if (shirtsData?.categorias) {

      const categoriesSerializeShirt = shirtsData.categorias.map((c: any) => ({
        title: c.nome.toUpperCase(),
        option: c.nome,
      }))

      setShirtCategories([
        {
          title: "Selecione uma opção",
          option: "",
        },
        ...categoriesSerializeShirt
      ]

      );
    }
  }, []);

  const handleSelectCategory = (e: any) => {
    const category = shirtsData.categorias.find(
      (c: any) => c.nome === e.target.value
    );

    const colors = category?.cores.map((cor: any) => ({
      title: cor.nome.toUpperCase(),
      option: cor.nome,
    })) || [];

    setShirtColors([
      { title: "Selecione uma opção", option: "" },
      ...colors
    ]);

    // salva categoria escolhida
    setValue("shirt.category", e.target.value);

    // limpa os próximos níveis
    setShirtSizes([]);
    setValue("shirt.color", "");
    setValue("shirt.size", "");
    setValue("shirt.price", null);
  };

  const handleSelectColor = (e: any) => {
    const category = shirtsData.categorias.find(
      (c: any) => c.nome === getValues("shirt.category")
    );

    const color = category?.cores.find((cor: any) => cor.nome === e.target.value);

    const sizes = color?.tamanhos.map((t: any) => ({
      title: t.tamanho.toUpperCase(),
      option: t.tamanho,
      preco: t.preco,
    })) || [];

    setShirtSizes([
      { title: "Selecione uma opção", option: "" },
      ...sizes
    ]);

    // salva cor escolhida
    setValue("shirt.color", e.target.value);

    // limpa tamanho e preço
    setValue("shirt.size", "");
    setValue("shirt.price", null);
  };

  const handleSelectSize = (e: any) => {
    const size = shirtSizes.find((s) => s.option === e.target.value);
    if (size) {
      setValue("shirt.size", size.option);
      setValue("shirt.price", size.preco);
    } else {
      // se resetar, limpa também
      setValue("shirt.size", "");
      setValue("shirt.price", null);
    }
  };

  const includesGI = enrollmentType === "gi" || enrollmentType?.toLowerCase()?.includes('absoluto');
  const includesGIAbsoluto = enrollmentType === "absolutGI" || enrollmentType?.toLowerCase()?.includes('absoluto');;
  const includesNOGIAbsoluto = enrollmentType === "absolutNOGI" || enrollmentType?.toLowerCase()?.includes('absoluto');;
  const includesNOGI = enrollmentType === "nogi" || enrollmentType?.toLowerCase()?.includes('absoluto');

  return (
    <div>

      {loading && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',   // centraliza horizontalmente
            alignItems: 'center',       // centraliza verticalmente
            backdropFilter: 'blur(6px)', // 👈 aplica o blur no fundo
            backgroundColor: 'rgba(255, 255, 255, 0.4)', // leve transparência
            zIndex: 2000,               // garante que fica acima de tudo
            gap: 2,
          }}
        >
          <Typography sx={{ fontFamily: 'Inter, sans-serif', fontSize: '1.1rem' }}>
            Aguarde, estamos carregando seus dados...
          </Typography>

          <CircularProgress sx={{ color: 'black' }} />
        </Box>
      )}

      <NavBar />
      <Content>
        <FormContainer onSubmit={handleSubmit(onSubmit)}>
          <PageTitle>INSCRIÇÃO</PageTitle>
          <PageDescription>
            {/* Essa inscrição é referente ao torneio: {tournament.name} */}
            Essa inscrição é referente ao torneio: {NomeDoTorneio.toUpperCase()}
          </PageDescription>

          <SelectFighters
            label="Escolha um atleta para esse evento"
            name="fightersId"
            register={register}
            hasError={!!errors.category}
            required
            error="Este campo é obrigatório"
            options={fighters}
            onChange={handleChange}
          />

          {selectedFighter && (
            <Fade in={!!selectedFighter} timeout={800} unmountOnExit>
              <Box
                sx={{
                  border: '1px solid black',
                  borderRadius: 2,
                  padding: '8px 12px',
                  mt: 1,
                  position: 'relative',
                  backgroundColor: '#fefefe',
                }}
              >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography
                    component="span"
                    variant="h6"
                    sx={{ display: 'block' }}
                  >
                    Confirme seus dados:
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                  }}
                >

                  <Stack spacing={0} sx={{ m: 0, p: 0 }}>
                    {(() => {
                      const firstUncheckedIndex = fields.findIndex((field, index) => {
                        const previousChecked = index === 0 || checkedStates[fields[index - 1].id];
                        return previousChecked && !checkedStates[field.id];
                      });

                      return fields.map((field, index) => {
                        const isFirst = index === 0;
                        const previousChecked = isFirst || checkedStates[fields[index - 1].id];
                        const isCurrentChecked = checkedStates[field.id];
                        const shouldShowEditIcon = index === firstUncheckedIndex;

                        return (
                          <Box
                            key={field.id}
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              opacity: previousChecked ? 1 : 0.4,
                              pointerEvents: previousChecked ? 'auto' : 'none',
                              transition: 'opacity 0.2s',
                            }}
                          >
                            <Checkbox
                              checked={isCurrentChecked}
                              onChange={() => handleCheckChange(field.id)}
                              color="primary"
                            />

                            <Typography
                              component="div"
                              sx={{
                                fontWeight: 500,
                                fontSize: '0.95rem',
                                display: 'flex',
                                fontFamily: 'inter, sans-serif',
                                alignItems: 'center',
                              }}
                            >
                              {field.label}:{' '}
                              <Box
                                component="span"
                                sx={{
                                  color: isCurrentChecked ? 'success.main' : 'error.main',
                                  fontWeight: 500,
                                  fontSize: 'inherit',
                                  fontFamily: 'inter, sans-serif',
                                  ml: 1,
                                }}
                              >
                                {field.value}
                              </Box>

                              <Box
                                onClick={shouldShowEditIcon ? handleEditAtlete : undefined}
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  ml: 1.5,
                                  cursor: shouldShowEditIcon ? 'pointer' : 'default',
                                  color: 'text.secondary',
                                  transition: 'color 0.2s',
                                  '&:hover': { color: shouldShowEditIcon ? 'black' : 'text.secondary' },
                                  minWidth: 90,
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  sx={{ mr: 0.5, visibility: shouldShowEditIcon ? 'visible' : 'hidden' }}
                                >
                                  Editar
                                </Typography>
                                <EditIcon sx={{ fontSize: '1.2rem', visibility: shouldShowEditIcon ? 'visible' : 'hidden' }} />
                              </Box>

                            </Typography>
                          </Box>
                        );
                      });
                    })()}
                  </Stack>
                </Box>
              </Box>
            </Fade>
          )}
          <Collapse in={allChecked} timeout={800} unmountOnExit>
            <Box>
              <FormControl style={{ marginTop: 20, marginBottom: 15 }}>
                <FormLabel id="demo-row-radio-buttons-group-label" style={{ color: "#33303E", fontFamily: 'inter, sans-serif' }}>
                  TIPO DA INSCRIÇÃO
                </FormLabel>
                <RadioGroup
                  aria-label="Filtrar por"
                  value={enrollmentType}
                  style={{ marginLeft: 5 }}
                  onChange={(e: any) => {
                    setEnrollmentType(e.target.value);
                    setValue("gi.category", "");
                    setValue("gi.weight", "");
                    setValue("gi.modalidade", "");
                    setValue("nogi.category", "");
                    setValue("nogi.weight", "");
                    setValue("nogi.modalidade", "");
                    setWeights([]);
                    setWeightsNOGI([]);
                  }}
                >
                  <StyledFormControlLabel value="gi" control={<Radio />} label="GI" />
                  <StyledFormControlLabel value="nogi" control={<Radio />} label="NOGI" />
                  <StyledFormControlLabel value="absolutGI" control={<Radio />} label="ABSOLUTO GI" /> 
                   <StyledFormControlLabel value="absolutNOGI" control={<Radio />} label="ABSOLUTO NOGI" />
                  <StyledFormControlLabel value="combo" control={<Radio />} label="COMBO (GI + NOGI)" />
                  <StyledFormControlLabel value="comboGiAbsoluto" control={<Radio />} label="COMBO (GI + ABSOLUTO GI)" /> 
                  <StyledFormControlLabel value="comboNogiAbsoluto" control={<Radio />} label="COMBO (NOGI + ABSOLUTO NOGI)" />
                  <StyledFormControlLabel value="comboGiNogiAbsolutoGi" control={<Radio />} label="COMBO (GI + NOGI + ABSOLUTO GI)" /> 
                  <StyledFormControlLabel value="comboGiNogiAbsolutoNogi" control={<Radio />} label="COMBO (GI + NOGI + ABSOLUTO NOGI )" />
                  <StyledFormControlLabel value="comboGiAbsolutoNogiAbsoluto" control={<Radio />} label="COMBO (GI + ABSOLUTO GI + NOGI + ABSOLUTO NOGI)" />
                </RadioGroup>
              </FormControl>

              <Collapse in={
                enrollmentType === "gi" ||
                enrollmentType === "combo" ||
                enrollmentType === "comboGiAbsoluto" ||
                enrollmentType === "comboGiNogiAbsolutoGi" ||
                enrollmentType === "comboGiNogiAbsolutoNogi" ||
                enrollmentType === "comboGiAbsolutoNogiAbsoluto" ||
                enrollmentType === "comboGiAbsolutoNogiAbsoluto"
              }
                timeout={800}
                unmountOnExit
              >
                <PageTitle>GI</PageTitle>

                <NoOptionsAlert
                  show={noCategoriesAvaliableGi && !!selectedFighter && allChecked}
                  type="categories"
                  fighterData={{
                    name: selectedFighter?.name || "",
                    age: ages[0]?.option,
                    gender: genre[0]?.title,
                    belt: belts[0]?.title,
                  }}
                />

                {!noCategoriesAvaliableGi && (
                  <>
                    <SelectCategories
                      label="Categoria"
                      name="gi.category"
                      register={register}
                      required
                      hasError={!!errors.category}
                      error="Este campo é obrigatório"
                      options={categories}
                      onChange={handleChangeWeights} />
                    <SelectCategories
                      label="Peso"
                      name="gi.weight"
                      register={register}
                      required
                      hasError={!!errors.category}
                      error="Este campo é obrigatório"
                      options={weights} />
                    <Controller
                      name="gi.modalidade"
                      control={control}
                      // valida só quando GI (ou COMBO) estiver ativo
                      rules={includesGI ? { required: "Selecione uma modalidade." } : undefined}
                      render={({ field, fieldState }) => (
                        <FormControl
                          component="fieldset"
                          error={!!fieldState.error}
                        >
                          <FormLabel component="legend" style={{ color: "#33303E", fontFamily: 'inter, sans-serif' }}>
                            Pessoa com deficiência - PcD?
                          </FormLabel>

                          <RadioGroup
                            row
                            aria-label="PcD"
                            value={field.value ?? ""} // usa o valor do RHF
                            onChange={(e) => field.onChange(e.target.value)} // alimenta o RHF
                          >
                            {modalidade.map((m) => (
                              <StyledFormControlLabel
                                key={m.option}
                                value={String(m.option)}
                                control={<Radio />}
                                label={m.title} />
                            ))}
                          </RadioGroup>

                          <Typography variant="caption" color="error" sx={{ ml: 1 }}>
                            {fieldState.error?.message}
                          </Typography>
                        </FormControl>
                      )}
                    />
                  </>
                )}

              </Collapse>

              <Collapse in={
                enrollmentType === "absolutGI" ||
                enrollmentType === "comboGiAbsoluto" ||
                enrollmentType === "comboGiNogiAbsolutoGi" ||
                enrollmentType === "comboGiAbsolutoNogiAbsoluto" ||
                enrollmentType === "comboGiAbsolutoNogiAbsoluto"
              }
                timeout={800}
                unmountOnExit
              >
                <PageTitle>ABSOLUTO GI</PageTitle>

                <NoOptionsAlert
                  show={noCategoriesAvaliableGiAbsoluto && !!selectedFighter && allChecked}
                  type="categories"
                  fighterData={{
                    name: selectedFighter?.name || "",
                    age: ages[0]?.option,
                    gender: genre[0]?.title,
                    belt: belts[0]?.title,
                  }}
                />

                {!noCategoriesAvaliableGiAbsoluto && (
                  <>
                    <SelectCategories
                      label="Categoria"
                      name="gi.absoluto.category"
                      register={register}
                      required
                      hasError={!!errors.category}
                      error="Este campo é obrigatório"
                      options={categoriesGiAbsoluto}
                      onChange={handleChangeWeightsGiAbsoluto}
                    />
                    <SelectCategories
                      label="Peso"
                      name="gi.absoluto.weight"
                      register={register}
                      required
                      hasError={!!errors.category}
                      error="Este campo é obrigatório"
                      options={weightsGiAbsoluto}
                    />
                    <Controller
                      name="gi.absoluto.modalidade"
                      control={control}
                      // valida só quando GI (ou COMBO) estiver ativo
                      rules={includesGIAbsoluto ? { required: "Selecione uma modalidade." } : undefined}
                      render={({ field, fieldState }) => (
                        <FormControl
                          component="fieldset"
                          error={!!fieldState.error}
                        >
                          <FormLabel component="legend" style={{ color: "#33303E", fontFamily: 'inter, sans-serif' }}>
                            Pessoa com deficiência - PcD?
                          </FormLabel>

                          <RadioGroup
                            row
                            aria-label="PcD"
                            value={field.value ?? ""} // usa o valor do RHF
                            onChange={(e) => field.onChange(e.target.value)} // alimenta o RHF
                          >
                            {modalidade.map((m) => (
                              <StyledFormControlLabel
                                key={m.option}
                                value={String(m.option)}
                                control={<Radio />}
                                label={m.title} />
                            ))}
                          </RadioGroup>

                          <Typography variant="caption" color="error" sx={{ ml: 1 }}>
                            {fieldState.error?.message}
                          </Typography>
                        </FormControl>
                      )}
                    />
                  </>
                )}

              </Collapse>

              <Collapse in={
                enrollmentType === "nogi" ||
                enrollmentType === "combo" ||
                enrollmentType === "comboNogiAbsoluto" ||
                enrollmentType === "comboGiNogiAbsolutoGi" ||
                enrollmentType === "comboGiNogiAbsolutoNogi" ||
                enrollmentType === "comboGiAbsolutoNogiAbsoluto"
              }
                timeout={800}
                unmountOnExit
              >
                <PageTitle>NOGI</PageTitle>

                <NoOptionsAlert
                  show={noCategoriesAvailableNogi && !!selectedFighter && allChecked}
                  type="categories"
                  fighterData={{
                    name: selectedFighter?.name || "",
                    age: ages[0]?.option,
                    gender: genre[0]?.title,
                    belt: belts[0]?.title,
                  }}
                />

                {!noCategoriesAvailableNogi && (
                  <>

                    <SelectCategories
                      label="Categoria"
                      name="nogi.category"
                      register={register}
                      required
                      hasError={!!errors.category}
                      error="Este campo é obrigatório"
                      options={categoriesNOGI}
                      onChange={handleChangeWeightsNOGI}
                    />

                    <SelectCategories
                      label="Peso"
                      name="nogi.weight"
                      register={register}
                      required
                      hasError={!!errors.category}
                      error="Este campo é obrigatório"
                      options={weightsNOGI}
                    />
                    <Controller
                      name="nogi.modalidade"
                      control={control}
                      // valida só quando GI (ou COMBO) estiver ativo
                      rules={includesNOGI ? { required: "Selecione uma modalidade." } : undefined}
                      render={({ field, fieldState }) => (
                        <FormControl
                          component="fieldset"
                          error={!!fieldState.error}
                        >
                          <FormLabel component="legend" style={{ color: "#33303E", fontFamily: 'inter, sans-serif' }}>
                            Pessoa com deficiência - PcD?
                          </FormLabel>

                          <RadioGroup
                            row
                            aria-label="PcD"
                            value={field.value ?? ""} // usa o valor do RHF
                            onChange={(e) => field.onChange(e.target.value)} // alimenta o RHF
                          >
                            {modalidade.map((m) => (
                              <StyledFormControlLabel
                                key={m.option}
                                value={String(m.option)}
                                control={<Radio />}
                                label={m.title} />
                            ))}
                          </RadioGroup>

                          <Typography variant="caption" color="error" sx={{ ml: 1 }}>
                            {fieldState.error?.message}
                          </Typography>
                        </FormControl>
                      )} />
                  </>
                )}

              </Collapse>

              <Collapse in={
                enrollmentType === "absolutNOGI" ||
                enrollmentType === "comboNogiAbsoluto" ||
                enrollmentType === "comboGiNogiAbsolutoNogi" ||
                enrollmentType === "comboGiAbsolutoNogiAbsoluto"
              }
                timeout={800}
                unmountOnExit
              >
                <PageTitle>ABSOLUTO NOGI</PageTitle>

                <NoOptionsAlert
                  show={noCategoriesAvailableNogi && !!selectedFighter && allChecked}
                  type="categories"
                  fighterData={{
                    name: selectedFighter?.name || "",
                    age: ages[0]?.option,
                    gender: genre[0]?.title,
                    belt: belts[0]?.title,
                  }}
                />

                {!noCategoriesAvailableNogi && (
                  <>

                    <SelectCategories
                      label="Categoria"
                      name="nogi.absoluto.category"
                      register={register}
                      required
                      hasError={!!errors.category}
                      error="Este campo é obrigatório"
                      options={categoriesNogiAbsoluto}
                      onChange={handleChangeWeightsNogiAbsoluto}
                    />

                    <SelectCategories
                      label="Peso"
                      name="nogi.absoluto.weight"
                      register={register}
                      required
                      hasError={!!errors.category}
                      error="Este campo é obrigatório"
                      options={weightsNogiAbsoluto}
                    />
                    <Controller
                      name="nogi.absoluto.modalidade"
                      control={control}
                      // valida só quando GI (ou COMBO) estiver ativo
                      rules={includesNOGIAbsoluto ? { required: "Selecione uma modalidade." } : undefined}
                      render={({ field, fieldState }) => (
                        <FormControl
                          component="fieldset"
                          error={!!fieldState.error}
                        >
                          <FormLabel component="legend" style={{ color: "#33303E", fontFamily: 'inter, sans-serif' }}>
                            Pessoa com deficiência - PcD?
                          </FormLabel>

                          <RadioGroup
                            row
                            aria-label="PcD"
                            value={field.value ?? ""} // usa o valor do RHF
                            onChange={(e) => field.onChange(e.target.value)} // alimenta o RHF
                          >
                            {modalidade.map((m) => (
                              <StyledFormControlLabel
                                key={m.option}
                                value={String(m.option)}
                                control={<Radio />}
                                label={m.title} />
                            ))}
                          </RadioGroup>

                          <Typography variant="caption" color="error" sx={{ ml: 1 }}>
                            {fieldState.error?.message}
                          </Typography>
                        </FormControl>
                      )} />
                  </>
                )}

              </Collapse>
            </Box>
          </Collapse>

          {allChecked && enrollmentType && (
            ((enrollmentType === "gi" && !noCategoriesAvaliableGi) ||
              (enrollmentType === "nogi" && !noCategoriesAvailableNogi) ||
              (enrollmentType === "combo" && !noCategoriesAvaliableGi && !noCategoriesAvailableNogi) ||
              (enrollmentType === "absolutNOGI" && !noCategoriesAvaliableNogiAbsoluto) ||
              (enrollmentType === "absolutGI" && !noCategoriesAvaliableGiAbsoluto) ||
              (enrollmentType === "comboGiAbsoluto" && !noCategoriesAvaliableGi && !noCategoriesAvaliableGiAbsoluto) ||
              (enrollmentType === "comboNogiAbsoluto" && !noCategoriesAvailableNogi) ||
              (enrollmentType === "comboGiNogiAbsolutoGi" && !noCategoriesAvaliableGi && !noCategoriesAvailableNogi && !noCategoriesAvaliableGiAbsoluto) ||
              (enrollmentType === "comboGiNogiAbsolutoNogi" && !noCategoriesAvaliableGi && !noCategoriesAvailableNogi) ||
              (enrollmentType === "comboGiAbsolutoNogiAbsoluto" && !noCategoriesAvaliableGi && !noCategoriesAvailableNogi && !noCategoriesAvaliableGiAbsoluto)) && (
              <>

                <Box sx={{ display: 'flex', flexDirection: 'column', mt: 2, gap: 2, mb: 1 }}>

                  {haveGuarantee && (
                    <Controller
                      name="wantsGuarantee"
                      control={control}
                      rules={{
                        validate: (value) =>
                          value === true || value === false ? true : "Selecione uma opção."
                      }}
                      render={({ field, fieldState }) => (
                        <FormControl component="fieldset" error={!!fieldState.error}>
                          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
                            <FormLabel component="legend" style={{ color: "#33303E", fontFamily: 'inter, sans-serif' }}>
                              Deseja incluir a garantia campeã?
                            </FormLabel>
                            <InfoOutlineIcon
                              onClick={() => setInfoModalOpen(true)}
                              sx={{ cursor: 'pointer' }}
                            />
                          </Box>

                          <RadioGroup
                            row
                            value={
                              wantsChampionGuarantee === null
                                ? ""
                                : wantsChampionGuarantee
                                  ? "sim"
                                  : "nao"
                            }
                            onChange={(e) => {
                              const value = e.target.value === "sim";
                              field.onChange(value);
                              setWantsChampionGuarantee(value);

                              if (value === true) {
                                setInfoModalOpen(true);
                              }
                            }}
                          >
                            <StyledFormControlLabel value="sim" control={<Radio />} label="Sim" />
                            <StyledFormControlLabel value="nao" control={<Radio />} label="Não" />
                          </RadioGroup>

                          <Typography variant="caption" color="error" sx={{ ml: 1 }}>
                            {fieldState.error?.message}
                          </Typography>
                        </FormControl>
                      )}
                    />
                  )}

                  {haveTshirt && (
                    <>
                      <Controller
                        name="wantsShirt"
                        control={control}
                        rules={{
                          validate: (value) => value === true || value === false ? true : "Selecione uma opção."
                        }}
                        render={({ field, fieldState }) => (
                          <FormControl component="fieldset" error={!!fieldState.error}>
                            <FormLabel component="legend" style={{ color: "#33303E", fontFamily: 'inter, sans-serif' }}>
                              Deseja comprar a camisa do evento?
                              {/* Deseja GANHAR a camisa do evento GRÁTIS? */}
                            </FormLabel>

                            <RadioGroup
                              row
                              value={field.value === undefined || field.value === null
                                ? ""
                                : field.value
                                  ? "sim"
                                  : "nao"}
                              onChange={(e) => {
                                const value = e.target.value === "sim";
                                field.onChange(value); // atualiza o RHF
                                setWantsShirt(value);
                              }}
                            >
                              <StyledFormControlLabel value="sim" control={<Radio />} label="Sim" />
                              <StyledFormControlLabel value="nao" control={<Radio />} label="Não" />
                            </RadioGroup>

                            <Typography variant="caption" color="error" sx={{ ml: 1 }}>
                              {fieldState.error?.message}
                            </Typography>
                          </FormControl>
                        )} />

                      <Collapse in={!!wantsShirt} timeout={800} unmountOnExit>
                        <Box sx={{ mt: 1 }}>
                          <PageTitle>Camisa</PageTitle>

                          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 350, position: "relative" }}>
                            {!imageLoaded && <CircularProgress size={28} sx={{ position: "absolute", color: "black" }} />}

                            <Fade in={imageLoaded} timeout={700}>
                              <img
                                src={camisaVender}
                                alt="CAMISETA CIANORTE"
                                style={{
                                  maxWidth: "500px",
                                  maxHeight: "350px",
                                  objectFit: "contain",
                                  display: imageLoaded ? "block" : "none",
                                }}
                                onLoad={() => setImageLoaded(true)}
                                onError={() => setImageLoaded(false)}
                              />
                            </Fade>
                          </Box>

                          <SelectCategories
                            label="Modelo"
                            name="shirt.category"
                            register={register}
                            required
                            hasError={!!errors.shirt}
                            error="Selecione uma categoria"
                            options={shirtCategories}
                            onChange={handleSelectCategory}
                          />

                          <SelectCategories
                            label="Cor"
                            name="shirt.color"
                            register={register}
                            required
                            hasError={!!errors.shirt}
                            error="Selecione uma cor"
                            options={shirtColors}
                            onChange={handleSelectColor}
                          />

                          <SelectCategories
                            label="Tamanho"
                            name="shirt.size"
                            register={register}
                            required
                            hasError={!!errors.shirt}
                            error="Selecione um tamanho"
                            options={shirtSizes}
                            onChange={handleSelectSize}
                          />
                        </Box>
                      </Collapse>
                    </>
                  )}
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Button type="submit" label="Inscrever" disabled={disabled} />
                </Box>
              </>
            )
          )}
        </FormContainer>

        {isEditModalOpen && (
          <EditFighterModal
            targetValue={selectedFighterId}
            fighter={selectedFighter}
            onUpdated={handleFighterUpdated}
            open={true}
            onClose={() => setIsEditModalOpen(false)}
          />
        )}
      </Content>

      <Dialog open={infoModalOpen} onClose={() => setInfoModalOpen(false)}>
        <DialogTitle>O que é a Garantia Campeã?</DialogTitle>

        <DialogContent>
          {/* container fixo da imagem */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: 380, // reserva o espaço máximo que a imagem ocupará
              mb: 2,
              position: "relative",
            }}
          >
            {!guaranteeImageLoaded && <CircularProgress size={28} sx={{ position: "absolute", color: "black" }} />}

            <Fade in={guaranteeImageLoaded} timeout={700}>
              <img
                src="/icons/garantia2.png"
                alt="garantia campeã"
                style={{
                  maxWidth: "400px",
                  maxHeight: "380px",
                  objectFit: "contain",
                  display: "block",
                }}
                onLoad={() => setGuaranteeImageLoaded(true)}
                onError={() => setGuaranteeImageLoaded(false)}
              />
            </Fade>
          </Box>

          <Typography
            variant="body1"
            sx={{ textAlign: "center", fontWeight: "bold" }}
          >
            Garanta já a sua adesão à GARANTIA CAMPEÃ e assegure o reembolso de 80% do
            valor da inscrição (excluindo produtos), em situações de lesão e/ou
            acidente. O benefício será concedido mediante contato e apresentação de
            laudo médico, até a segunda-feira que antecede o início do evento.
          </Typography>

          <Typography
            variant="body1"
            sx={{ textAlign: "left", fontWeight: "bold", color: "green", mt: 2 }}
          >
            Valor: R$10
          </Typography>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 1,
              justifyContent: "center",
              alignItems: "center",
              width: 1000,
            }}
          >
            <Button onClick={() => setInfoModalOpen(false)} label="CONFIRMAR" />

            <ButtonMui
              onClick={() => setInfoModalOpen(false)}
              sx={{
                cursor: "pointer",
                background: "#ff0101af",
                borderRadius: "8px",
                padding: "18px",
                border: "none",
                fontFamily: "Inter, sans-serif",
                lineHeight: "150%",
                color: "#ffffff",
                width: "100%",
              }}
            >
              Cancelar
            </ButtonMui>
          </Box>
        </DialogActions>
      </Dialog>

    </div>
  );
};

export default EnrollmentCopaParintinenseDeJiuJitsu2026;
